import { isNonEmptyArray } from '../../utils/helpers.utils';
import { FilterChips } from 'constants/ExpressConstants';
import { UserConfigValues } from '../../config/redux/common/commonSlice.types';

export interface CourierSwitchFilterParams {
    activeChip: string;
    courierSwitchStatuses: FilterChips[];
    ordersCount: number;
    onDemandConfigDetails: UserConfigValues[];
    onDemandConfigDetailsStore: UserConfigValues[];
    hubCode: string[];
}

export function computeShouldShowCourierSwitchingFilter(params: CourierSwitchFilterParams): boolean {
    const {
        activeChip,
        courierSwitchStatuses,
        ordersCount,
        onDemandConfigDetails,
        onDemandConfigDetailsStore,
        hubCode,
    } = params;

    if (!courierSwitchStatuses.includes(activeChip as FilterChips)) return false;
    if (!ordersCount) return false;

    const onDemandGlobal = isNonEmptyArray(onDemandConfigDetails) && (onDemandConfigDetails[0]?.value as any) === true;
    if (onDemandGlobal) return true;

    const storeHubCodes = isNonEmptyArray(onDemandConfigDetailsStore)
        ? onDemandConfigDetailsStore[0]?.value?.split(',').map((v: string) => v.trim())
        : [];
    return isNonEmptyArray(hubCode) && hubCode.some((hub: string) => storeHubCodes?.includes(hub));
}
